import { useExtendedRouter } from "hooks";
import type { ItemListName } from "./AhPlusPricingPlans.d";
import { usePricingPlanDetailsConfig } from "./config";

const VIEW_ITEM_EVENT_NAME = "view_item_list";
const ITEM_NAME = "AirHelpPlus Membership";
const ITEM_BRAND = "AirHelp";
const ITEM_CATEGORY = "1YearMembership";
const ITEM_CATEGORY_2 = "Subscription";

const useEssentialPlanTrackingItem = (itemListName: ItemListName) => {
  const plansConfig = usePricingPlanDetailsConfig();

  const { essential: essentialPlan } = plansConfig;

  return {
    item_id: essentialPlan.tracking.item_id,
    item_name: ITEM_NAME,
    index: 1,
    item_brand: ITEM_BRAND,
    item_category: ITEM_CATEGORY,
    item_category2: ITEM_CATEGORY_2,
    item_list_name: itemListName,
    item_variant: essentialPlan.tracking.item_variant,
    price: essentialPlan.price,
    quantity: 1,
    affiliation: "",
    coupon: "",
    discount: "",
  };
};

const useCompletePlanTrackingItem = (itemListName: ItemListName) => {
  const plansConfig = usePricingPlanDetailsConfig();

  const { complete: completePlan } = plansConfig;

  return {
    item_id: completePlan.tracking.item_id,
    item_name: ITEM_NAME,
    index: 2,
    item_brand: ITEM_BRAND,
    item_category: ITEM_CATEGORY,
    item_category2: ITEM_CATEGORY_2,
    item_list_name: itemListName,
    item_variant: completePlan.tracking.item_variant,
    price: completePlan.price,
    quantity: 1,
    affiliation: "",
    coupon: "",
    discount: "",
  };
};

export const useGetViewItemTrackingEvent = () => {
  const {
    isHomepage,
    query: { slug },
  } = useExtendedRouter();
  const pageSlug = isHomepage ? "homepage" : slug[0];

  const itemListName: ItemListName = {
    homepage: "homepage_item_list_name" as const,
    "airhelp-plus": "ahp_lp_item_list_name" as const,
    airpayout: "airpayout_lp_item_list_name" as const,
    airluggage: "airluggage_lp_item_list_name" as const,
  }[pageSlug];

  return {
    event: VIEW_ITEM_EVENT_NAME,
    item_list_name: itemListName,
    items: [useEssentialPlanTrackingItem(itemListName), useCompletePlanTrackingItem(itemListName)],
  } as const;
};
